import AgentEduConfirm from './AgentEduConfirm';

export default AgentEduConfirm;
